import React, { Component } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import './team.css'
import CookieConsentComponent from '../../Components/CookieConsent'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import { connect } from 'react-redux'
import sobre from '../../images/img-sobre.png'
import sobre2 from '../../images/img-sobre-2.png'
import { Link } from 'react-router-dom'

const items = [
    {
        title: 'Cuidar',
        text: 'Nutrir todos os pontos de contato da experiência de nossos usuários dentro do universo crypto.'
    },
    {
        title: 'Performar',
        text: 'Atingir o máximo potencial na execução de tudo o que propomos.'
    },
    {
        title: 'Simplificar',
        text: 'Tornar crypto simples: na utilização, no entendimento, na relação.'
    }
]

class Sobre extends Component {
    constructor() {
        super();
          this.state = {
          fillBackground: false,
        };
      }

    componentDidMount = async () => {
        const { onLoad, userid, logged } = this.props
        if(logged && onLoad && userid) {
            onLoad(userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        return (
            <div id="sobreSection">
                <Navbar fillBackground={this.state.fillBackground} />
                <div className="section sobreWrapper headerWrapper">
                    <Container>
                        <Row>
                            <Col md={7} className="p-0 dflexMobile">
                                <h2 className="pageCall deskLeftMobileCenter">Somos a <br/><span className="tx-pink">primeira <br/>cryptocare</span> <br/>do mundo</h2>
                                <p className="headerDescProducts wDesk100-wMobile80 deskLeftMobileCenter">Existimos para criar a melhor e mais completa experiência no setor: cuidamos da sua jornada e transformamos o modo como você interage com esse universo.</p>
                                <p className="headerDescProducts tx-pink wDesk100-wMobile80 deskLeftMobileCenter mt-5 mb-5">Crypto precisa ser fácil. Crypto precisa ser simples.</p>
                                <Link to="/cadastro" className='anchorBtn'>Inicie sua jornada</Link>
                            </Col>
                            <Col md={5} className="d-flex align-items-center p-0">
                                <img src={sobre} className="img-fluid img-banner" />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="section sobreWrapper headerWrapper ">
                    <Container className='mt-5 mb-5'>
                        <Row className='flex-column-reverse flex-md-row'>
                            <Col md={4} lg={5} className="d-flex align-items-center justify-content-center p-0">
                                <img src={sobre2} className="img-fluid img2" />
                            </Col>
                            <Col md={8} lg={7} className="p-0 d-flex align-items-center justify-content-center">
                                <p className="text-white p-desc textP">
                                    Somos uma empresa feita por pessoas que atuam no setor desde 2015. Estamos aqui desde o início, e viemos para ficar.<br /><br />Passamos grande parte da nossa história utilizando diversos serviços complexos e não-intuitivos, a partir disso, percebemos que a experiência poderia ser transformada para o melhor.<br /><br />Trabalhamos diariamente para criar a melhor experiência no mundo da criptoeconomia e blockchain, independente da necessidade ou nível de conhecimento, com produtos, serviços e experiências transformadoras.
                                    <br /><br />
                                    <strong>Nossa missão: Acelerar a transição do mundo para a criptoeconomia.</strong>
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="section sobreWrapper headerWrapper">
                    <Container>
                        <Row>
                            <Col md={12}>
                                <h2 className="text-white subtitlePages w-100 mt-4 mb-4">Nossos princípios </h2>
                            </Col>
                        </Row>
                        <Row className="mt-5">
                            {items.map(item => (
                                <Col md={4}>
                                    <h3 className="tx-pink font-weight-bold">{item.title}</h3>
                                    <p className="text-white textP mb-5">{item.text}</p>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
                <CookieConsentComponent />
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Sobre)